
import * as Li9maXJlYmFzZS13ZWItc2RrLm1qcw from './firebase-web-sdk.mjs';
import * as Li9za2lrby5tanM from './skiko.mjs';
import * as QGpzLWpvZGEvY29yZQ from '@js-joda/core';
import * as cGFrbw from 'pako';
import * as d2FzbTpqcy1zdHJpbmc from './minutepilot-web.js-builtins.mjs';

const wasmJsTag = WebAssembly.JSTag;
const wasmTag = wasmJsTag ?? new WebAssembly.Tag({ parameters: ['externref'] });

// Placed here to give access to it from externals (js_code)
let wasmExports;
let require;

if (typeof process !== 'undefined' && process.release.name === 'node') {
    const module = await import(/* webpackIgnore: true */'node:module');
    const importMeta = import.meta;
    require = module.default.createRequire(importMeta.url);
}

export function setWasmExports(exports) {
    wasmExports = exports;
}

const _ref_Li9maXJlYmFzZS13ZWItc2RrLm1qcw_ = Li9maXJlYmFzZS13ZWItc2RrLm1qcw;
const _ref_Li9za2lrby5tanM_ = Li9za2lrby5tanM;
const _ref_Li9za2lrby5tanM_c2tpa29BcGk = Li9za2lrby5tanM.skikoApi;
const _ref_QGpzLWpvZGEvY29yZQ_ = QGpzLWpvZGEvY29yZQ;
const _ref_cGFrbw_ = cGFrbw;

const cachedJsObjects = new WeakMap();
function getCachedJsObject(ref, ifNotCached) {
    if (typeof ref !== 'object' && typeof ref !== 'function') return ifNotCached;
    const cached = cachedJsObjects.get(ref);
    if (cached !== void 0) return cached;
    cachedJsObjects.set(ref, ifNotCached);
    return ifNotCached;
}

const js_code = {
    'kotlin.createJsError' : (message, cause) => new Error(message, { cause }),
    'kotlin.wasm.internal.jsThrow' : wasmTag === wasmJsTag ? (e) => { throw e; } : () => {},
    'kotlin.wasm.internal.getJsEmptyString' : () => '',
    'kotlin.wasm.internal.externrefToDouble' : (ref) => Number(ref),
    'kotlin.wasm.internal.externrefToInt' : (ref) => Number(ref),
    'kotlin.wasm.internal.intToExternref' : (x) => x,
    'kotlin.wasm.internal.doubleToExternref' : (x) => x,
    'kotlin.wasm.internal.externrefToString' : (ref) => String(ref),
    'kotlin.wasm.internal.externrefEquals' : (lhs, rhs) => lhs === rhs,
    'kotlin.wasm.internal.externrefHashCode' : 
    (() => {
    const dataView = new DataView(new ArrayBuffer(8));
    function numberHashCode(obj) {
        if ((obj | 0) === obj) {
            return obj | 0;
        } else {
            dataView.setFloat64(0, obj, true);
            return (dataView.getInt32(0, true) * 31 | 0) + dataView.getInt32(4, true) | 0;
        }
    }

    const hashCodes = new WeakMap();
    function getObjectHashCode(obj) {
        const res = hashCodes.get(obj);
        if (res === undefined) {
            const POW_2_32 = 4294967296;
            const hash = (Math.random() * POW_2_32) | 0;
            hashCodes.set(obj, hash);
            return hash;
        }
        return res;
    }

    function getStringHashCode(str) {
        var hash = 0;
        for (var i = 0; i < str.length; i++) {
            var code  = str.charCodeAt(i);
            hash  = (hash * 31 + code) | 0;
        }
        return hash;
    }

    return (obj) => {
        if (obj == null) {
            return 0;
        }
        switch (typeof obj) {
            case "object":
            case "function":
                return getObjectHashCode(obj);
            case "number":
                return numberHashCode(obj);
            case "boolean":
                return obj ? 1231 : 1237;
            default:
                return getStringHashCode(String(obj)); 
        }
    }
    })(),
    'kotlin.wasm.internal.isNullish' : (ref) => ref == null,
    'kotlin.wasm.internal.getJsTrue' : () => true,
    'kotlin.wasm.internal.getJsFalse' : () => false,
    'kotlin.wasm.internal.kotlinUIntToJsNumberUnsafe' : (x) => x >>> 0,
    'kotlin.wasm.internal.kotlinULongToJsBigIntUnsafe' : (x) => x & 0xFFFFFFFFFFFFFFFFn,
    'kotlin.wasm.internal.newJsArray' : () => [],
    'kotlin.wasm.internal.jsArrayPush' : (array, element) => { array.push(element); },
    'kotlin.wasm.internal.getCachedJsObject_$external_fun' : (p0, p1) => getCachedJsObject(p0, p1),
    'kotlin.wasm.internal.itoa32_$external_fun' : (p0) => String(p0),
    'kotlin.wasm.internal.itoa64_$external_fun' : (p0) => String(p0),
    'kotlin.wasm.internal.utoa64_$external_fun' : (p0) => String(p0),
    'kotlin.wasm.internal.utoa32_$external_fun' : (p0) => String(p0),
    'kotlin.js.jsCatch' : (f) => { 
        let result = null;
        try { 
            f();
        } catch (e) {
           result = e;
        }
        return result;
         },
    'kotlin.js.__convertKotlinClosureToJsClosure_(()->Unit)' : (f) => getCachedJsObject(f, () => wasmExports['__callFunction_(()->Unit)'](f, )),
    'kotlin.js.jsThrow' : (e) => { throw e; },
    'kotlin.io.printlnImpl' : (message) => console.log(message),
    'kotlin.io.printError' : (error) => console.error(error),
    'kotlin.js.jsArrayGet' : (array, index) => array[index],
    'kotlin.js.jsArraySet' : (array, index, value) => { array[index] = value },
    'kotlin.js.JsArray_$external_fun' : () => new Array(),
    'kotlin.js.length_$external_prop_getter' : (_this) => _this.length,
    'kotlin.js.JsArray_$external_class_instanceof' : (x) => x instanceof Array,
    'kotlin.js.JsArray_$external_class_get' : () => Array,
    'kotlin.js.stackPlaceHolder_js_code' : () => (''),
    'kotlin.js.message_$external_prop_getter' : (_this) => _this.message,
    'kotlin.js.name_$external_prop_setter' : (_this, v) => _this.name = v,
    'kotlin.js.stack_$external_prop_getter' : (_this) => _this.stack,
    'kotlin.js.kotlinException_$external_prop_getter' : (_this) => _this.kotlinException,
    'kotlin.js.kotlinException_$external_prop_setter' : (_this, v) => _this.kotlinException = v,
    'kotlin.js.JsError_$external_class_instanceof' : (x) => x instanceof Error,
    'kotlin.js.JsNumber_$external_class_instanceof' : (x) => typeof x === 'number',
    'kotlin.js.JsNumber_$external_class_get' : () => JsNumber,
    'kotlin.js.JsString_$external_class_instanceof' : (x) => typeof x === 'string',
    'kotlin.js.JsString_$external_class_get' : () => JsString,
    'kotlin.js.then_$external_fun' : (_this, p0) => _this.then(p0),
    'kotlin.js.__convertKotlinClosureToJsClosure_((Js?)->Js?)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Js?)->Js?)'](f, p0)),
    'kotlin.js.then_$external_fun_1' : (_this, p0, p1) => _this.then(p0, p1),
    'kotlin.js.__convertKotlinClosureToJsClosure_((Js)->Js?)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Js)->Js?)'](f, p0)),
    'kotlin.js.catch_$external_fun' : (_this, p0) => _this.catch(p0),
    'kotlin.random.initialSeed' : () => ((Math.random() * Math.pow(2, 32)) | 0),
    'kotlin.wasm.internal.getJsClassName' : (jsKlass) => jsKlass.name,
    'kotlin.wasm.internal.instanceOf' : (ref, jsKlass) => ref instanceof jsKlass,
    'kotlin.wasm.internal.getConstructor' : (obj) => obj.constructor,
    'kotlin.time.Date_$external_fun' : () => new Date(),
    'kotlin.time.getTime_$external_fun' : (_this, ) => _this.getTime(),
    'kotlin.time.tryGetPerformance' : () => typeof globalThis !== 'undefined' && typeof globalThis.performance !== 'undefined' ? globalThis.performance : null,
    'kotlin.time.getPerformanceNow' : (performance) => performance.now(),
    'kotlin.time.dateNow' : () => Date.now(),
    'kotlinx.coroutines.tryGetProcess' : () => (typeof(process) !== 'undefined' && typeof(process.nextTick) === 'function') ? process : null,
    'kotlinx.coroutines.tryGetWindow' : () => (typeof(window) !== 'undefined' && window != null && typeof(window.addEventListener) === 'function') ? window : null,
    'kotlinx.coroutines.nextTick_$external_fun' : (_this, p0) => _this.nextTick(p0),
    'kotlinx.coroutines.error_$external_fun' : (_this, p0) => _this.error(p0),
    'kotlinx.coroutines.console_$external_prop_getter' : () => console,
    'kotlinx.coroutines.createScheduleMessagePoster' : (process) => () => Promise.resolve(0).then(process),
    'kotlinx.coroutines.__callJsClosure_(()->Unit)' : (f, ) => f(),
    'kotlinx.coroutines.createRescheduleMessagePoster' : (window) => () => window.postMessage('dispatchCoroutine', '*'),
    'kotlinx.coroutines.subscribeToWindowMessages' : (window, process) => {
        const handler = (event) => {
            if (event.source == window && event.data == 'dispatchCoroutine') {
                event.stopPropagation();
                process();
            }
        }
        window.addEventListener('message', handler, true);
    },
    'kotlinx.coroutines.setTimeout' : (window, handler, timeout) => window.setTimeout(handler, timeout),
    'kotlinx.coroutines.clearTimeout' : (handle) => { if (typeof clearTimeout !== 'undefined') clearTimeout(handle); },
    'kotlinx.coroutines.clearTimeout_$external_fun' : (_this, p0) => _this.clearTimeout(p0),
    'kotlinx.coroutines.setTimeout_$external_fun' : (p0, p1) => setTimeout(p0, p1),
    'no.synth.kmpzip.crypto.cryptoGetRandomValues' : (buf) => globalThis.crypto.getRandomValues(buf),
    'no.synth.kmpzip.internal.Uint8Array_$external_fun' : (p0) => new Uint8Array(p0),
    'no.synth.kmpzip.internal.length_$external_prop_getter' : (_this) => _this.length,
    'no.synth.kmpzip.zip.Inflate_$external_fun' : (p0) => new _ref_cGFrbw_.Inflate(p0),
    'no.synth.kmpzip.zip.err_$external_prop_getter' : (_this) => _this.err,
    'no.synth.kmpzip.zip.msg_$external_prop_getter' : (_this) => _this.msg,
    'no.synth.kmpzip.zip.ended_$external_prop_getter' : (_this) => _this.ended,
    'no.synth.kmpzip.zip.chunks_$external_prop_getter' : (_this) => _this.chunks,
    'no.synth.kmpzip.zip.result_$external_prop_getter' : (_this) => _this.result,
    'no.synth.kmpzip.zip.strm_$external_prop_getter' : (_this) => _this.strm,
    'no.synth.kmpzip.zip.push_$external_fun' : (_this, p0, p1) => _this.push(p0, p1),
    'no.synth.kmpzip.zip.Deflate_$external_fun' : (p0) => new _ref_cGFrbw_.Deflate(p0),
    'no.synth.kmpzip.zip.err_$external_prop_getter_1' : (_this) => _this.err,
    'no.synth.kmpzip.zip.msg_$external_prop_getter_1' : (_this) => _this.msg,
    'no.synth.kmpzip.zip.ended_$external_prop_getter_1' : (_this) => _this.ended,
    'no.synth.kmpzip.zip.chunks_$external_prop_getter_1' : (_this) => _this.chunks,
    'no.synth.kmpzip.zip.result_$external_prop_getter_1' : (_this) => _this.result,
    'no.synth.kmpzip.zip.push_$external_fun_1' : (_this, p0, p1) => _this.push(p0, p1),
    'no.synth.kmpzip.zip.pakoInflateOptions' : (raw, gzip, chunkSize) => ({ raw: raw, windowBits: gzip ? 31 : 15, chunkSize: chunkSize }),
    'no.synth.kmpzip.zip.strmAvailIn' : (strm) => strm.avail_in,
    'no.synth.kmpzip.zip.pakoDeflateOptions' : (level, raw, gzip, chunkSize) => ({ level: level, raw: raw, gzip: gzip, chunkSize: chunkSize }),
    'no.synth.kmpzip.zip.latin1StringToUint8Array' : (s, length) => (() => { const arr = new Uint8Array(length); for (let i = 0; i < length; i++) arr[i] = s.charCodeAt(i); return arr; })(),
    'no.synth.kmpzip.zip.uint8ArrayToLatin1String' : (arr, start, length) => (() => {
            const slice = arr.subarray(start, start + length);
            const CHUNK = 16384;
            let result = '';
            for (let i = 0; i < slice.length; i += CHUNK) {
                result += String.fromCharCode.apply(null, slice.subarray(i, i + CHUNK));
            }
            return result;
        })(),
    'no.synth.kmpzip.zip.chunksHead' : (chunks) => chunks[0],
    'no.synth.kmpzip.zip.chunksShift' : (chunks) => chunks.shift(),
    'no.synth.kmpzip.zip.chunksTrimHead' : (chunks, prefix) => chunks[0] = chunks[0].subarray(prefix),
    'no.synth.kmpzip.zip.chunksLength' : (chunks) => chunks.length,
    'org.khronos.webgl.getMethodImplForInt8Array' : (obj, index) => obj[index],
    'org.khronos.webgl.byteLength_$external_prop_getter' : (_this) => _this.byteLength,
    'org.khronos.webgl.Int8Array_$external_fun' : (p0, p1, p2, isDefault0, isDefault1) => new Int8Array(p0, isDefault0 ? undefined : p1, isDefault1 ? undefined : p2, ),
    'org.khronos.webgl.length_$external_prop_getter' : (_this) => _this.length,
    'org.khronos.webgl.Uint8Array_$external_class_instanceof' : (x) => x instanceof Uint8Array,
    'org.w3c.dom.clipboard.clipboardData_$external_prop_getter' : (_this) => _this.clipboardData,
    'org.w3c.dom.clipboard.ClipboardEvent_$external_class_instanceof' : (x) => x instanceof ClipboardEvent,
    'org.w3c.dom.css.cursor_$external_prop_setter' : (_this, v) => _this.cursor = v,
    'org.w3c.dom.css.display_$external_prop_setter' : (_this, v) => _this.display = v,
    'org.w3c.dom.css.fontSize_$external_prop_getter' : (_this) => _this.fontSize,
    'org.w3c.dom.css.fontSize_$external_prop_setter' : (_this, v) => _this.fontSize = v,
    'org.w3c.dom.css.height_$external_prop_setter' : (_this, v) => _this.height = v,
    'org.w3c.dom.css.left_$external_prop_setter' : (_this, v) => _this.left = v,
    'org.w3c.dom.css.opacity_$external_prop_setter' : (_this, v) => _this.opacity = v,
    'org.w3c.dom.css.outline_$external_prop_setter' : (_this, v) => _this.outline = v,
    'org.w3c.dom.css.position_$external_prop_setter' : (_this, v) => _this.position = v,
    'org.w3c.dom.css.top_$external_prop_setter' : (_this, v) => _this.top = v,
    'org.w3c.dom.css.whiteSpace_$external_prop_setter' : (_this, v) => _this.whiteSpace = v,
    'org.w3c.dom.css.width_$external_prop_setter' : (_this, v) => _this.width = v,
    'org.w3c.dom.css.setProperty_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.setProperty(p0, p1, isDefault0 ? undefined : p2, ),
    'org.w3c.dom.css.style_$external_prop_getter' : (_this) => _this.style,
    'org.w3c.dom.events.type_$external_prop_getter' : (_this) => _this.type,
    'org.w3c.dom.events.target_$external_prop_getter' : (_this) => _this.target,
    'org.w3c.dom.events.cancelable_$external_prop_getter' : (_this) => _this.cancelable,
    'org.w3c.dom.events.timeStamp_$external_prop_getter' : (_this) => _this.timeStamp,
    'org.w3c.dom.events.preventDefault_$external_fun' : (_this, ) => _this.preventDefault(),
    'org.w3c.dom.events.Event_$external_class_instanceof' : (x) => x instanceof Event,
    'org.w3c.dom.events.Event_$external_class_get' : () => Event,
    'org.w3c.dom.events.key_$external_prop_getter' : (_this) => _this.key,
    'org.w3c.dom.events.code_$external_prop_getter' : (_this) => _this.code,
    'org.w3c.dom.events.ctrlKey_$external_prop_getter' : (_this) => _this.ctrlKey,
    'org.w3c.dom.events.shiftKey_$external_prop_getter' : (_this) => _this.shiftKey,
    'org.w3c.dom.events.altKey_$external_prop_getter' : (_this) => _this.altKey,
    'org.w3c.dom.events.metaKey_$external_prop_getter' : (_this) => _this.metaKey,
    'org.w3c.dom.events.repeat_$external_prop_getter' : (_this) => _this.repeat,
    'org.w3c.dom.events.isComposing_$external_prop_getter' : (_this) => _this.isComposing,
    'org.w3c.dom.events.keyCode_$external_prop_getter' : (_this) => _this.keyCode,
    'org.w3c.dom.events.KeyboardEvent_$external_class_instanceof' : (x) => x instanceof KeyboardEvent,
    'org.w3c.dom.events.KeyboardEvent_$external_class_get' : () => KeyboardEvent,
    'org.w3c.dom.events.deltaX_$external_prop_getter' : (_this) => _this.deltaX,
    'org.w3c.dom.events.deltaY_$external_prop_getter' : (_this) => _this.deltaY,
    'org.w3c.dom.events.deltaMode_$external_prop_getter' : (_this) => _this.deltaMode,
    'org.w3c.dom.events.DOM_DELTA_PIXEL_$external_prop_getter' : (_this) => _this.DOM_DELTA_PIXEL,
    'org.w3c.dom.events.DOM_DELTA_LINE_$external_prop_getter' : (_this) => _this.DOM_DELTA_LINE,
    'org.w3c.dom.events.DOM_DELTA_PAGE_$external_prop_getter' : (_this) => _this.DOM_DELTA_PAGE,
    'org.w3c.dom.events.Companion_$external_object_getInstance' : () => WheelEvent,
    'org.w3c.dom.events.WheelEvent_$external_class_instanceof' : (x) => x instanceof WheelEvent,
    'org.w3c.dom.events.WheelEvent_$external_class_get' : () => WheelEvent,
    'org.w3c.dom.events.FocusEvent_$external_class_instanceof' : (x) => x instanceof FocusEvent,
    'org.w3c.dom.events.FocusEvent_$external_class_get' : () => FocusEvent,
    'org.w3c.dom.events.addEventListener_$external_fun' : (_this, p0, p1, p2) => _this.addEventListener(p0, p1, p2),
    'org.w3c.dom.events.__convertKotlinClosureToJsClosure_((Js)->Unit)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Js)->Unit)'](f, p0)),
    'org.w3c.dom.events.addEventListener_$external_fun_1' : (_this, p0, p1) => _this.addEventListener(p0, p1),
    'org.w3c.dom.events.addEventListener_$external_fun_2' : (_this, p0, p1) => _this.addEventListener(p0, p1),
    'org.w3c.dom.events.removeEventListener_$external_fun' : (_this, p0, p1) => _this.removeEventListener(p0, p1),
    'org.w3c.dom.events.removeEventListener_$external_fun_1' : (_this, p0, p1) => _this.removeEventListener(p0, p1),
    'org.w3c.dom.events.clientX_$external_prop_getter' : (_this) => _this.clientX,
    'org.w3c.dom.events.clientY_$external_prop_getter' : (_this) => _this.clientY,
    'org.w3c.dom.events.ctrlKey_$external_prop_getter_1' : (_this) => _this.ctrlKey,
    'org.w3c.dom.events.shiftKey_$external_prop_getter_1' : (_this) => _this.shiftKey,
    'org.w3c.dom.events.altKey_$external_prop_getter_1' : (_this) => _this.altKey,
    'org.w3c.dom.events.metaKey_$external_prop_getter_1' : (_this) => _this.metaKey,
    'org.w3c.dom.events.button_$external_prop_getter' : (_this) => _this.button,
    'org.w3c.dom.events.buttons_$external_prop_getter' : (_this) => _this.buttons,
    'org.w3c.dom.events.offsetX_$external_prop_getter' : (_this) => _this.offsetX,
    'org.w3c.dom.events.offsetY_$external_prop_getter' : (_this) => _this.offsetY,
    'org.w3c.dom.events.isComposing_$external_prop_getter_1' : (_this) => _this.isComposing,
    'org.w3c.dom.events.InputEvent_$external_class_instanceof' : (x) => x instanceof InputEvent,
    'org.w3c.dom.events.InputEvent_$external_class_get' : () => InputEvent,
    'org.w3c.dom.events.data_$external_prop_getter' : (_this) => _this.data,
    'org.w3c.dom.events.CompositionEvent_$external_class_instanceof' : (x) => x instanceof CompositionEvent,
    'org.w3c.dom.events.CompositionEvent_$external_class_get' : () => CompositionEvent,
    'org.w3c.dom.ShadowRootInit' : (mode) => ({ mode: mode }),
    'org.w3c.dom.AddEventListenerOptions_js_code' : (passive, once, capture) => ({ passive: passive, once: once, capture: capture }),
    'org.w3c.dom.location_$external_prop_getter' : (_this) => _this.location,
    'org.w3c.dom.navigator_$external_prop_getter' : (_this) => _this.navigator,
    'org.w3c.dom.devicePixelRatio_$external_prop_getter' : (_this) => _this.devicePixelRatio,
    'org.w3c.dom.requestAnimationFrame_$external_fun' : (_this, p0) => _this.requestAnimationFrame(p0),
    'org.w3c.dom.__convertKotlinClosureToJsClosure_((Double)->Unit)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Double)->Unit)'](f, p0)),
    'org.w3c.dom.matchMedia_$external_fun' : (_this, p0) => _this.matchMedia(p0),
    'org.w3c.dom.getComputedStyle_$external_fun' : (_this, p0, p1, isDefault0) => _this.getComputedStyle(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.matches_$external_prop_getter' : (_this) => _this.matches,
    'org.w3c.dom.addListener_$external_fun' : (_this, p0) => _this.addListener(p0),
    'org.w3c.dom.MediaQueryList_$external_class_instanceof' : (x) => x instanceof MediaQueryList,
    'org.w3c.dom.MediaQueryList_$external_class_get' : () => MediaQueryList,
    'org.w3c.dom.protocol_$external_prop_getter' : (_this) => _this.protocol,
    'org.w3c.dom.search_$external_prop_getter' : (_this) => _this.search,
    'org.w3c.dom.tabIndex_$external_prop_setter' : (_this, v) => _this.tabIndex = v,
    'org.w3c.dom.innerText_$external_prop_setter' : (_this, v) => _this.innerText = v,
    'org.w3c.dom.click_$external_fun' : (_this, ) => _this.click(),
    'org.w3c.dom.focus_$external_fun' : (_this, ) => _this.focus(),
    'org.w3c.dom.blur_$external_fun' : (_this, ) => _this.blur(),
    'org.w3c.dom.HTMLElement_$external_class_instanceof' : (x) => x instanceof HTMLElement,
    'org.w3c.dom.HTMLElement_$external_class_get' : () => HTMLElement,
    'org.w3c.dom.dropEffect_$external_prop_setter' : (_this, v) => _this.dropEffect = v,
    'org.w3c.dom.setDragImage_$external_fun' : (_this, p0, p1, p2) => _this.setDragImage(p0, p1, p2),
    'org.w3c.dom.getData_$external_fun' : (_this, p0) => _this.getData(p0),
    'org.w3c.dom.setData_$external_fun' : (_this, p0, p1) => _this.setData(p0, p1),
    'org.w3c.dom.documentElement_$external_prop_getter' : (_this) => _this.documentElement,
    'org.w3c.dom.body_$external_prop_getter' : (_this) => _this.body,
    'org.w3c.dom.head_$external_prop_getter' : (_this) => _this.head,
    'org.w3c.dom.activeElement_$external_prop_getter' : (_this) => _this.activeElement,
    'org.w3c.dom.createElement_$external_fun' : (_this, p0, p1, isDefault0) => _this.createElement(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.hasFocus_$external_fun' : (_this, ) => _this.hasFocus(),
    'org.w3c.dom.getElementById_$external_fun' : (_this, p0) => _this.getElementById(p0),
    'org.w3c.dom.querySelector_$external_fun' : (_this, p0) => _this.querySelector(p0),
    'org.w3c.dom.namespaceURI_$external_prop_getter' : (_this) => _this.namespaceURI,
    'org.w3c.dom.localName_$external_prop_getter' : (_this) => _this.localName,
    'org.w3c.dom.id_$external_prop_setter' : (_this, v) => _this.id = v,
    'org.w3c.dom.classList_$external_prop_getter' : (_this) => _this.classList,
    'org.w3c.dom.shadowRoot_$external_prop_getter' : (_this) => _this.shadowRoot,
    'org.w3c.dom.clientWidth_$external_prop_getter' : (_this) => _this.clientWidth,
    'org.w3c.dom.clientHeight_$external_prop_getter' : (_this) => _this.clientHeight,
    'org.w3c.dom.getAttribute_$external_fun' : (_this, p0) => _this.getAttribute(p0),
    'org.w3c.dom.getAttributeNS_$external_fun' : (_this, p0, p1) => _this.getAttributeNS(p0, p1),
    'org.w3c.dom.setAttribute_$external_fun' : (_this, p0, p1) => _this.setAttribute(p0, p1),
    'org.w3c.dom.removeAttribute_$external_fun' : (_this, p0) => _this.removeAttribute(p0),
    'org.w3c.dom.attachShadow_$external_fun' : (_this, p0) => _this.attachShadow(p0),
    'org.w3c.dom.getBoundingClientRect_$external_fun' : (_this, ) => _this.getBoundingClientRect(),
    'org.w3c.dom.Element_$external_class_instanceof' : (x) => x instanceof Element,
    'org.w3c.dom.nodeName_$external_prop_getter' : (_this) => _this.nodeName,
    'org.w3c.dom.isConnected_$external_prop_getter' : (_this) => _this.isConnected,
    'org.w3c.dom.parentNode_$external_prop_getter' : (_this) => _this.parentNode,
    'org.w3c.dom.childNodes_$external_prop_getter' : (_this) => _this.childNodes,
    'org.w3c.dom.firstChild_$external_prop_getter' : (_this) => _this.firstChild,
    'org.w3c.dom.textContent_$external_prop_setter' : (_this, v) => _this.textContent = v,
    'org.w3c.dom.hasChildNodes_$external_fun' : (_this, ) => _this.hasChildNodes(),
    'org.w3c.dom.lookupPrefix_$external_fun' : (_this, p0) => _this.lookupPrefix(p0),
    'org.w3c.dom.appendChild_$external_fun' : (_this, p0) => _this.appendChild(p0),
    'org.w3c.dom.removeChild_$external_fun' : (_this, p0) => _this.removeChild(p0),
    'org.w3c.dom.width_$external_prop_getter' : (_this) => _this.width,
    'org.w3c.dom.width_$external_prop_setter' : (_this, v) => _this.width = v,
    'org.w3c.dom.height_$external_prop_getter' : (_this) => _this.height,
    'org.w3c.dom.height_$external_prop_setter' : (_this, v) => _this.height = v,
    'org.w3c.dom.HTMLCanvasElement_$external_class_instanceof' : (x) => x instanceof HTMLCanvasElement,
    'org.w3c.dom.HTMLCanvasElement_$external_class_get' : () => HTMLCanvasElement,
    'org.w3c.dom.HTMLDivElement_$external_class_instanceof' : (x) => x instanceof HTMLDivElement,
    'org.w3c.dom.HTMLDivElement_$external_class_get' : () => HTMLDivElement,
    'org.w3c.dom.HTMLTextAreaElement_$external_class_instanceof' : (x) => x instanceof HTMLTextAreaElement,
    'org.w3c.dom.HTMLTextAreaElement_$external_class_get' : () => HTMLTextAreaElement,
    'org.w3c.dom.TouchEvent_$external_class_instanceof' : (x) => x instanceof TouchEvent,
    'org.w3c.dom.TouchEvent_$external_class_get' : () => TouchEvent,
    'org.w3c.dom.matches_$external_prop_getter_1' : (_this) => _this.matches,
    'org.w3c.dom.MediaQueryListEvent_$external_class_instanceof' : (x) => x instanceof MediaQueryListEvent,
    'org.w3c.dom.MediaQueryListEvent_$external_class_get' : () => MediaQueryListEvent,
    'org.w3c.dom.dataTransfer_$external_prop_getter' : (_this) => _this.dataTransfer,
    'org.w3c.dom.DragEvent_$external_class_instanceof' : (x) => x instanceof DragEvent,
    'org.w3c.dom.DragEvent_$external_class_get' : () => DragEvent,
    'org.w3c.dom.add_$external_fun' : (_this, p0) => _this.add(...p0),
    'org.w3c.dom.userAgent_$external_prop_getter' : (_this) => _this.userAgent,
    'org.w3c.dom.language_$external_prop_getter' : (_this) => _this.language,
    'org.w3c.dom.onload_$external_prop_setter' : (_this, v) => _this.onload = v,
    'org.w3c.dom.caches_$external_prop_getter' : (_this) => _this.caches,
    'org.w3c.dom.fetch_$external_fun' : (_this, p0, p1, isDefault0) => _this.fetch(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.localStorage_$external_prop_getter' : (_this) => _this.localStorage,
    'org.w3c.dom.item_$external_fun' : (_this, p0) => _this.item(p0),
    'org.w3c.dom.top_$external_prop_getter' : (_this) => _this.top,
    'org.w3c.dom.left_$external_prop_getter' : (_this) => _this.left,
    'org.w3c.dom.remove_$external_fun' : (_this, ) => _this.remove(),
    'org.w3c.dom.Companion_$external_object_getInstance' : () => ({}),
    'org.w3c.dom.data_$external_prop_getter' : (_this) => _this.data,
    'org.w3c.dom.MessageEvent_$external_class_instanceof' : (x) => x instanceof MessageEvent,
    'org.w3c.dom.MessageEvent_$external_class_get' : () => MessageEvent,
    'org.w3c.dom.getItem_$external_fun' : (_this, p0) => _this.getItem(p0),
    'org.w3c.dom.setItem_$external_fun' : (_this, p0, p1) => _this.setItem(p0, p1),
    'org.w3c.dom.download_$external_prop_setter' : (_this, v) => _this.download = v,
    'org.w3c.dom.HTMLAnchorElement_$external_class_instanceof' : (x) => x instanceof HTMLAnchorElement,
    'org.w3c.dom.href_$external_prop_setter' : (_this, v) => _this.href = v,
    'org.w3c.dom.onmessage_$external_prop_setter' : (_this, v) => _this.onmessage = v,
    'org.w3c.dom.onerror_$external_prop_setter' : (_this, v) => _this.onerror = v,
    'org.w3c.dom.terminate_$external_fun' : (_this, ) => _this.terminate(),
    'org.w3c.dom.postMessage_$external_fun' : (_this, p0, p1, isDefault0) => _this.postMessage(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.src_$external_prop_setter' : (_this, v) => _this.src = v,
    'org.w3c.dom.async_$external_prop_setter' : (_this, v) => _this.async = v,
    'org.w3c.dom.defer_$external_prop_setter' : (_this, v) => _this.defer = v,
    'org.w3c.dom.HTMLScriptElement_$external_class_instanceof' : (x) => x instanceof HTMLScriptElement,
    'org.w3c.dom.HTMLScriptElement_$external_class_get' : () => HTMLScriptElement,
    'org.w3c.dom.message_$external_prop_getter' : (_this) => _this.message,
    'org.w3c.dom.ErrorEvent_$external_class_instanceof' : (x) => x instanceof ErrorEvent,
    'org.w3c.dom.parsing.DOMParser_$external_fun' : () => new DOMParser(),
    'org.w3c.dom.parsing.parseFromString_$external_fun' : (_this, p0, p1) => _this.parseFromString(p0, p1),
    'org.w3c.dom.pointerevents.pointerId_$external_prop_getter' : (_this) => _this.pointerId,
    'org.w3c.dom.pointerevents.pressure_$external_prop_getter' : (_this) => _this.pressure,
    'org.w3c.dom.pointerevents.PointerEvent_$external_class_instanceof' : (x) => x instanceof PointerEvent,
    'org.w3c.dom.pointerevents.PointerEvent_$external_class_get' : () => PointerEvent,
    'org.w3c.fetch.ok_$external_prop_getter' : (_this) => _this.ok,
    'org.w3c.fetch.clone_$external_fun' : (_this, ) => _this.clone(),
    'org.w3c.fetch.arrayBuffer_$external_fun' : (_this, ) => _this.arrayBuffer(),
    'org.w3c.fetch.blob_$external_fun' : (_this, ) => _this.blob(),
    'org.w3c.fetch.Response_$external_class_instanceof' : (x) => x instanceof Response,
    'org.w3c.fetch.Response_$external_class_get' : () => Response,
    'org.w3c.performance.now_$external_fun' : (_this, ) => _this.now(),
    'org.w3c.performance.performance_$external_prop_getter' : (_this) => _this.performance,
    'org.w3c.workers.CacheQueryOptions_js_code' : (ignoreSearch, ignoreMethod, ignoreVary, cacheName) => ({ ignoreSearch: ignoreSearch, ignoreMethod: ignoreMethod, ignoreVary: ignoreVary, cacheName: cacheName }),
    'org.w3c.workers.match_$external_fun' : (_this, p0, p1, isDefault0) => _this.match(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.workers.put_$external_fun' : (_this, p0, p1) => _this.put(p0, p1),
    'org.w3c.workers.open_$external_fun' : (_this, p0) => _this.open(p0),
    'org.w3c.workers.delete_$external_fun' : (_this, p0) => _this.delete(p0),
    'kotlinx.browser.window_$external_prop_getter' : () => window,
    'kotlinx.browser.document_$external_prop_getter' : () => document,
    'org.w3c.dom.length_$external_prop_getter' : (_this) => _this.length,
    'androidx.sqlite.driver.web.fileName_$external_prop_setter' : (_this, v) => _this.fileName = v,
    'androidx.sqlite.driver.web.databaseId_$external_prop_getter' : (_this) => _this.databaseId,
    'androidx.sqlite.driver.web.databaseId_$external_prop_setter' : (_this, v) => _this.databaseId = v,
    'androidx.sqlite.driver.web.sql_$external_prop_setter' : (_this, v) => _this.sql = v,
    'androidx.sqlite.driver.web.statementId_$external_prop_getter' : (_this) => _this.statementId,
    'androidx.sqlite.driver.web.parameterCount_$external_prop_getter' : (_this) => _this.parameterCount,
    'androidx.sqlite.driver.web.columnNames_$external_prop_getter' : (_this) => _this.columnNames,
    'androidx.sqlite.driver.web.statementId_$external_prop_setter' : (_this, v) => _this.statementId = v,
    'androidx.sqlite.driver.web.bindings_$external_prop_setter' : (_this, v) => _this.bindings = v,
    'androidx.sqlite.driver.web.rows_$external_prop_getter' : (_this) => _this.rows,
    'androidx.sqlite.driver.web.columnTypes_$external_prop_getter' : (_this) => _this.columnTypes,
    'androidx.sqlite.driver.web.statementId_$external_prop_setter_1' : (_this, v) => _this.statementId = v,
    'androidx.sqlite.driver.web.databaseId_$external_prop_setter_1' : (_this, v) => _this.databaseId = v,
    'androidx.sqlite.driver.web.cmd_$external_prop_setter' : (_this, v) => _this.cmd = v,
    'androidx.sqlite.driver.web.util.initExternal' : () => ({}),
    'androidx.sqlite.driver.web.worker.id_$external_prop_getter' : (_this) => _this.id,
    'androidx.sqlite.driver.web.worker.id_$external_prop_setter' : (_this, v) => _this.id = v,
    'androidx.sqlite.driver.web.worker.data_$external_prop_getter' : (_this) => _this.data,
    'androidx.sqlite.driver.web.worker.data_$external_prop_setter' : (_this, v) => _this.data = v,
    'androidx.sqlite.driver.web.worker.error_$external_prop_getter' : (_this) => _this.error,
    'androidx.sqlite.driver.web.worker.error_$external_prop_setter' : (_this, v) => _this.error = v,
    'com.zhentech.minutepilot.core.database.createSqliteWorker' : () => new Worker(new URL('minutepilot-sqlite-wasm-worker/worker.js', import.meta.url), { type: 'module' }),
    'androidx.compose.runtime.internal.weakMap_js_code' : () => (new WeakMap()),
    'androidx.compose.runtime.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
    'androidx.compose.runtime.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
    'androidx.compose.runtime.internal.WeakRef_$external_fun' : (p0) => new WeakRef(p0),
    'androidx.compose.runtime.internal.deref_$external_fun' : (_this, ) => _this.deref(),
    'org.jetbrains.skiko.GL_$external_prop_getter' : () => _ref_Li9za2lrby5tanM_.GL,
    'org.jetbrains.skia.impl.FinalizationRegistry_$external_fun' : (p0) => new FinalizationRegistry(p0),
    'org.jetbrains.skia.impl.register_$external_fun' : (_this, p0, p1, p2) => _this.register(p0, p1, p2),
    'org.jetbrains.skia.impl.unregister_$external_fun' : (_this, p0) => _this.unregister(p0),
    'org.jetbrains.skia.impl._releaseLocalCallbackScope_$external_fun' : () => _ref_Li9za2lrby5tanM_c2tpa29BcGk._releaseLocalCallbackScope(),
    'org.jetbrains.skiko.wasm.createDefaultContextAttributes' : () => {
        return {
            alpha: 1,
            depth: 1,
            stencil: 8,
            antialias: 0,
            premultipliedAlpha: 1,
            preserveDrawingBuffer: 0,
            preferLowPowerToHighPerformance: 0,
            failIfMajorPerformanceCaveat: 0,
            enableExtensionsByDefault: 1,
            explicitSwapControl: 0,
            renderViaOffscreenBackBuffer: 0,
            majorVersion: 2,
        }
    }
    ,
    'org.jetbrains.skiko.wasm.awaitSkiko_$external_prop_getter' : () => _ref_Li9za2lrby5tanM_.awaitSkiko,
    'org.jetbrains.skiko.createContext_$external_fun' : (_this, p0, p1) => _this.createContext(p0, p1),
    'org.jetbrains.skiko.makeContextCurrent_$external_fun' : (_this, p0) => _this.makeContextCurrent(p0),
    'org.jetbrains.skiko.getNavigatorInfo' : () => navigator.userAgentData ? navigator.userAgentData.platform : navigator.platform,
    'org.jetbrains.skiko.defaultFetchInit_js_code' : () => ({}),
    'org.jetbrains.skiko.jsCatch' : function (f) { try { f(); } catch (e) { return e;}; return null; },
    'org.jetbrains.skiko.jsThrow' : (e) => { throw e; },
    'androidx.lifecycle.WeakRef_$external_fun' : (p0) => new WeakRef(p0),
    'androidx.lifecycle.deref_$external_fun' : (_this, ) => _this.deref(),
    'androidx.compose.ui.text.intl.getUserPreferredLanguagesAsArray' : () => window.navigator.languages,
    'androidx.compose.ui.text.FinalizationRegistry_$external_fun' : (p0) => new FinalizationRegistry(p0),
    'androidx.compose.ui.text.register_$external_fun' : (_this, p0, p1) => _this.register(p0, p1),
    'androidx.compose.ui.text.WeakRef_$external_fun' : (p0) => new WeakRef(p0),
    'androidx.compose.ui.text.deref_$external_fun' : (_this, ) => _this.deref(),
    'androidx.compose.ui.text.intl.parseLanguageTagToIntlLocale' : (languageTag) => new Intl.Locale(languageTag),
    'androidx.compose.ui.text.intl._language_$external_prop_getter' : (_this) => _this.language,
    'androidx.compose.ui.text.intl._script_$external_prop_getter' : (_this) => _this.script,
    'androidx.compose.ui.text.intl._region_$external_prop_getter' : (_this) => _this.region,
    'androidx.compose.ui.text.intl._baseName_$external_prop_getter' : (_this) => _this.baseName,
    'androidx.compose.ui.internal.weakMap_js_code' : () => (new WeakMap()),
    'androidx.compose.ui.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
    'androidx.compose.ui.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
    'androidx.compose.ui.platform.createClipboardItemWithPlainText' : (text) => [new ClipboardItem({'text/plain': new Blob([text], { type: 'text/plain' })})],
    'androidx.compose.ui.platform.emptyClipboardItems' : () => [new ClipboardItem({'text/plain': new Blob([''], { type: 'text/plain' })})],
    'androidx.compose.ui.platform.invalidClipboardItems' : () => [],
    'androidx.compose.ui.platform.warn' : (text) => { console.warn(text) },
    'androidx.compose.ui.events.withSignal' : (signal) => ({signal: signal}),
    'androidx.compose.ui.events.withSignalAndPassive' : (signal, passive) => ({signal: signal, passive: passive}),
    'androidx.compose.ui.events.AbortController_$external_fun' : () => new AbortController(),
    'androidx.compose.ui.events.signal_$external_prop_getter' : (_this) => _this.signal,
    'androidx.compose.ui.internal.focusExt' : (element, _preventScroll) => element.focus({ preventScroll: _preventScroll }),
    'androidx.compose.ui.node.WeakRef_$external_fun' : (p0) => new WeakRef(p0),
    'androidx.compose.ui.node.deref_$external_fun' : (_this, ) => _this.deref(),
    'androidx.compose.ui.platform.setBackingInputBox' : (container, left, top, width, height) => { 
        container.style.setProperty("--compose-internal-web-backing-input-left", left);
        container.style.setProperty("--compose-internal-web-backing-input-top", top);
        container.style.setProperty("--compose-internal-web-backing-input-width", width);
        container.style.setProperty("--compose-internal-web-backing-input-height", height)
     },
    'androidx.compose.ui.platform.isVibrationSupported' : () => 
            typeof window !== 'undefined' &&
            window.navigator != null &&
            typeof window.navigator.vibrate === 'function'
        ,
    'androidx.compose.ui.platform.vibrate' : (pattern) => { window.navigator.vibrate(pattern) },
    'androidx.compose.ui.platform.isTypedEvent' : (evt) => !evt.metaKey && !evt.ctrlKey && evt.key.charAt(0) === evt.key,
    'androidx.compose.ui.platform.value_$external_prop_setter' : (_this, v) => _this.value = v,
    'androidx.compose.ui.platform.selectionStart_$external_prop_getter' : (_this) => _this.selectionStart,
    'androidx.compose.ui.platform.selectionEnd_$external_prop_getter' : (_this) => _this.selectionEnd,
    'androidx.compose.ui.platform.setSelectionRange_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.setSelectionRange(p0, p1, isDefault0 ? undefined : p2, ),
    'androidx.compose.ui.platform.data_$external_prop_getter' : (_this) => _this.data,
    'androidx.compose.ui.platform.inputType_$external_prop_getter' : (_this) => _this.inputType,
    'androidx.compose.ui.platform.textRangeStart_$external_prop_getter' : (_this) => _this.textRangeStart,
    'androidx.compose.ui.platform.textRangeStart_$external_prop_setter' : (_this, v) => _this.textRangeStart = v,
    'androidx.compose.ui.platform.textRangeEnd_$external_prop_getter' : (_this) => _this.textRangeEnd,
    'androidx.compose.ui.platform.textRangeEnd_$external_prop_setter' : (_this, v) => _this.textRangeEnd = v,
    'androidx.compose.ui.platform.activeElement_$external_prop_getter' : (_this) => _this.activeElement,
    'androidx.compose.ui.platform.getRootNode_$external_fun' : (_this, ) => _this.getRootNode(),
    'androidx.compose.ui.platform.getW3CClipboard' : () => window.navigator.clipboard,
    'androidx.compose.ui.platform.isSecureContext' : () => window.isSecureContext === true,
    'androidx.compose.ui.platform.isFullClipboardApiSupported' : () => Boolean(
            window.navigator.clipboard && 
            window.navigator.clipboard.write && 
            window.navigator.clipboard.read && 
            typeof(ClipboardItem) !== 'undefined'
            )
        ,
    'androidx.compose.ui.platform.isFallbackWriteTextApiAvailable' : () => Boolean(window.navigator.clipboard && window.navigator.clipboard.writeText),
    'androidx.compose.ui.platform.types_$external_prop_getter' : (_this) => _this.types,
    'androidx.compose.ui.platform.getType_$external_fun' : (_this, p0) => _this.getType(p0),
    'androidx.compose.ui.platform.read_$external_fun' : (_this, ) => _this.read(),
    'androidx.compose.ui.platform.write_$external_fun' : (_this, p0) => _this.write(p0),
    'androidx.compose.ui.platform.writeText_$external_fun' : (_this, p0) => _this.writeText(p0),
    'androidx.compose.ui.platform.W3CTemporaryClipboard_$external_class_instanceof' : (x) => x instanceof Clipboard,
    'androidx.compose.ui.platform.W3CTemporaryClipboard_$external_class_get' : () => Clipboard,
    'androidx.compose.ui.platform.isFullWakeLockApiSupported' : () => Boolean(
            window.navigator.wakeLock && 
            typeof(WakeLockSentinel) !== 'undefined'
            )
        ,
    'androidx.compose.ui.platform.accessibility.removeAllChildrenOf' : (element) => { element.replaceChildren() },
    'androidx.compose.ui.platform.accessibility.setA11YAriaRole' : (element, ariaRoleId) => { 
            var roleValue = "";
            switch (ariaRoleId) {
                case 0: // Role.Button
                    roleValue = "button";
                    break;
                case 1: // Role.Checkbox
                    roleValue = "checkbox";
                    break;
                case 2: // Role.Switch
                    roleValue = "switch";
                    break;
                case 3: // Role.RadioButton
                    roleValue = "radio";
                    break;
                case 4: // Role.Tab
                    roleValue = "tab";
                    break;
                case 5: // Role.Image
                    roleValue = "img";
                    break;
                case 6: // Role.DropdownList
                    roleValue = "menu";
                    break;
                case 7: // heading https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/heading_role
                    roleValue = "heading";
                    break;
                case 8: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/textbox_role
                    roleValue = "textbox";
                    break;
                case 9: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/list_role
                    roleValue = "list";
                    break;
                case 10: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/grid_role
                    roleValue = "grid";
                    break;
                default:
                    break;
            }
            if (roleValue.length > 0) { 
                element.setAttribute("role", roleValue);
            } else {
                element.removeAttribute("role");
            }
         },
    'androidx.compose.ui.platform.accessibility.setSizeAndPosition' : (element, left, top, width, height) => { 
           element.style.left = "" + left + "px";
           element.style.top = "" + top + "px";
           element.style.width = "" + width + "px";
           element.style.height = "" + height + "px";
         },
    'androidx.compose.ui.window.documentIsVisible' : () => document.visibilityState === 'visible',
    'androidx.compose.ui.window.isTouchEvent' : (event) => event.pointerType === 'touch',
    'androidx.compose.ui.window.releasePointerCapture' : (target, pointerId) => { try { target.releasePointerCapture(pointerId) } catch (e) {} },
    'androidx.compose.ui.window.isMouseEvent' : (event) => event.pointerType === 'mouse',
    'androidx.compose.ui.window.setPointerCapture' : (target, pointerId) => { try { target.setPointerCapture(pointerId) } catch (e) {} },
    'androidx.compose.ui.window.getCoalescedEvents' : (pointerEvent) => pointerEvent.getCoalescedEvents ? pointerEvent.getCoalescedEvents() : [],
    'androidx.compose.ui.window.getPointerEventCode' : (event) => {
            switch (event.type) {
              case 'pointerdown':
                return 1; // PointerEventType.Press
              case 'pointerup':
                return 2; // PointerEventType.Release
              case 'pointermove':
                return 3; // PointerEventType.Move
              case 'pointerenter':
                return 4; //PointerEventType.Enter
              case 'pointerleave':
                return 5; //PointerEventType.Exit
              default:
                return 0; // PointerEventType.Unknown
            } 
        },
    'androidx.compose.ui.window.activeElement_$external_prop_getter' : (_this) => _this.activeElement,
    'androidx.compose.ui.window.isMatchMediaSupported' : () => window.matchMedia != undefined,
    'androidx.compose.foundation.internal.isClipboardWriteSupported' : () => Boolean(window.navigator.clipboard && (window.navigator.clipboard.write || window.navigator.clipboard.writeText)),
    'androidx.compose.foundation.internal.isClipboardReadSupported' : () => Boolean(window.navigator.clipboard && window.navigator.clipboard.read),
    'androidx.compose.foundation.internal.getTextFromBlob' : (blob) => blob.text(),
    'androidx.compose.foundation.internal.doesJsArrayContainValue' : (jsArray, value) => jsArray.includes(value),
    'androidx.compose.foundation.text.EventListener' : (handler) => (event) => { handler(event) },
    'androidx.compose.foundation.gestures.legacyWheelDeltaX' : (event) => (event.wheelDeltaX == null) ? NaN : event.wheelDeltaX,
    'androidx.compose.foundation.gestures.legacyWheelDeltaY' : (event) => (event.wheelDeltaY == null) ? NaN : event.wheelDeltaY,
    'org.jetbrains.compose.resources.Locale_$external_fun' : (p0) => new Intl.Locale(p0),
    'org.jetbrains.compose.resources.language_$external_prop_getter' : (_this) => _this.language,
    'org.jetbrains.compose.resources.script_$external_prop_getter' : (_this) => _this.script,
    'org.jetbrains.compose.resources.region_$external_prop_getter' : (_this) => _this.region,
    'org.jetbrains.compose.resources.jsExportBlobAsArrayBuffer' : (blob) => blob.arrayBuffer(),
    'org.jetbrains.compose.resources.jsFetchWithSignal' : (url, signal) => window.fetch(url, { signal }),
    'org.jetbrains.compose.resources.AbortController_$external_fun' : () => new AbortController(),
    'org.jetbrains.compose.resources.signal_$external_prop_getter' : (_this) => _this.signal,
    'org.jetbrains.compose.resources.abort_$external_fun' : (_this, ) => _this.abort(),
    'org.jetbrains.compose.resources.copyArrayBufferToWasmMemory' : (ab, ptr) => {
          const data = new Uint8Array(ab);
          new Uint8Array(wasmExports.memory.buffer).set(data, ptr);
    },
    'org.jetbrains.compose.resources.supportsCacheApi' : () => Boolean(window.caches),
    'androidx.compose.material3.internal.weakMap_js_code' : () => (new WeakMap()),
    'androidx.compose.material3.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
    'androidx.compose.material3.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
    'com.mmk.kmpauth.google.initializeGsiId' : 
        (clientId, autoSelect, callback) => {
            google.accounts.id.initialize({
                client_id: clientId,
                auto_select: autoSelect,
                callback: callback,
                use_fedcm_for_prompt: true
            });
        }
    ,
    'com.mmk.kmpauth.google.getCredentialResponseIdToken' : (credentialResponse) => credentialResponse.credential,
    'com.mmk.kmpauth.google.promptGsiId' : (momentCallback) => google.accounts.id.prompt(momentCallback),
    'com.mmk.kmpauth.google.isMomentTerminal' : (moment) => 
            (() => {
               try {
                 if (moment.isSkippedMoment && moment.isSkippedMoment()) return true;
                 if (moment.isDismissedMoment && moment.isDismissedMoment()
                     && moment.getDismissedReason && moment.getDismissedReason() !== 'credential_returned') return true;
                 if (moment.isNotDisplayed && moment.isNotDisplayed()) return true;
               } catch (e) { return true; }
               return false;
            })()
        ,
    'com.mmk.kmpauth.google.getErrorType' : (error) => error && error.type ? error.type : null,
    'com.mmk.kmpauth.google.initTokenClient' : (tokenClientConfig) => google.accounts.oauth2.initTokenClient(tokenClientConfig),
    'com.mmk.kmpauth.google.requestAccessToken' : (tokenClient) => tokenClient.requestAccessToken(),
    'com.mmk.kmpauth.google.jwtClaim' : (jwt, name) => 
            (() => {
               try {
                 const payload = JSON.parse(atob(jwt.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
                 const value = payload[name];
                 return value == null ? null : String(value);
               } catch (e) { return null; }
            })()
        ,
    'com.mmk.kmpauth.google.getTokenResponseError' : (tokenResponse) => tokenResponse.error,
    'com.mmk.kmpauth.google.getTokenResponseIdToken' : (tokenResponse) => tokenResponse.id_token,
    'com.mmk.kmpauth.google.getTokenResponseAccessToken' : (tokenResponse) => tokenResponse.access_token,
    'com.mmk.kmpauth.google.fetchGoogleUserInfoPromise' : (accessToken) => 
           (() => {
              const headers = { Authorization: "Bearer " + accessToken };
              const fetchOptions = { headers };
              return fetch("https://www.googleapis.com/oauth2/v3/userinfo", fetchOptions).then(res => res.json());
           })()
        ,
    'com.mmk.kmpauth.google.getUserInfoEmail' : (userInfo) => userInfo.email,
    'com.mmk.kmpauth.google.getUserInfoName' : (userInfo) => userInfo.name,
    'com.mmk.kmpauth.google.getUserInfoPicture' : (userInfo) => userInfo.picture,
    'com.mmk.kmpauth.google.createEmptyObject' : () => ({}),
    'com.mmk.kmpauth.google.setTokenClientConfigPropsImpl' : 
        (config, clientId, scope, prompt, callback, errorCallback) => {
            config.client_id = clientId;
            config.scope = scope;
            config.prompt = prompt;
            config.callback = callback;
            config.error_callback = errorCallback;
        }
    ,
    'com.mmk.kmpauth.firebase.backend.fetchPostText' : 
        (url, body) => fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: body
        }).then(r => r.text())
    ,
    'com.mmk.kmpauth.firebase.backend.localStorageGet' : (k) => window.localStorage.getItem(k),
    'com.mmk.kmpauth.firebase.backend.localStorageRemove' : (k) => window.localStorage.removeItem(k),
    'com.mmk.kmpauth.firebase.backend.localStorageSet' : (k, v) => window.localStorage.setItem(k, v),
    'com.zhentech.minutepilot.web.webBrowserReportsOnline' : () => typeof navigator === 'undefined' || navigator.onLine !== false,
    'com.zhentech.minutepilot.web.addBrowserNetworkListeners' : (listener) => 
        {
        window.addEventListener('online', listener);
        window.addEventListener('offline', listener);
        }
        ,
    'com.zhentech.minutepilot.web.removeBrowserNetworkListeners' : (listener) => 
        {
        window.removeEventListener('online', listener);
        window.removeEventListener('offline', listener);
        }
        ,
    'com.zhentech.minutepilot.web.webLocalStorageRead' : (key) => {
            try { return globalThis.localStorage ? globalThis.localStorage.getItem(key) : null; }
            catch (_) { return null; }
        },
    'com.zhentech.minutepilot.web.webLocalStorageWrite' : (key, value) => {
            try {
                if (!globalThis.localStorage) return false;
                globalThis.localStorage.setItem(key, value);
                return globalThis.localStorage.getItem(key) === value;
            } catch (_) { return false; }
        },
    'com.zhentech.minutepilot.web.installBrowserDocumentDropReceiver' : (maxSourceBytes, oversizedDocumentMessage, onDropped, onRejected) => { 
            const receiverKey = '__minutePilotDocumentDropReceiver';
            const dragOverKey = '__minutePilotDocumentDragOver';
            const dropKey = '__minutePilotDocumentDrop';
            const readGenerationKey = '__minutePilotDocumentDropReadGeneration';
            if (window[dragOverKey]) window.removeEventListener('dragover', window[dragOverKey]);
            if (window[dropKey]) window.removeEventListener('drop', window[dropKey]);
            window[receiverKey] = onDropped;
            window[dragOverKey] = (event) => {
              if (event.dataTransfer && event.dataTransfer.files && event.dataTransfer.files.length) {
                event.preventDefault();
                event.dataTransfer.dropEffect = 'copy';
              }
            };
            window[dropKey] = (event) => {
              const file = event.dataTransfer && event.dataTransfer.files && event.dataTransfer.files[0];
              if (!file || !window[receiverKey]) return;
              event.preventDefault();
              const readGeneration = (Number(window[readGenerationKey]) || 0) + 1;
              window[readGenerationKey] = readGeneration;
              if (file.size > maxSourceBytes) {
                onRejected(event.clientX, event.clientY, oversizedDocumentMessage, readGeneration);
                return;
              }
              const reader = new FileReader();
              reader.onerror = () => window[receiverKey](event.clientX, event.clientY, file.name || '', file.type || '', file.size || 0, '', readGeneration);
              reader.onload = () => window[receiverKey](event.clientX, event.clientY, file.name || '', file.type || '', file.size || 0, reader.result || '', readGeneration);
              reader.readAsDataURL(file);
            };
            window.addEventListener('dragover', window[dragOverKey]);
            window.addEventListener('drop', window[dropKey]);
             },
    'com.zhentech.minutepilot.web.__convertKotlinClosureToJsClosure_((Double,Double,String,String,Double,String,Double)->Unit)' : (f) => getCachedJsObject(f, (p0, p1, p2, p3, p4, p5, p6) => wasmExports['__callFunction_((Double,Double,String,String,Double,String,Double)->Unit)'](f, p0, p1, p2, p3, p4, p5, p6)),
    'com.zhentech.minutepilot.web.__convertKotlinClosureToJsClosure_((Double,Double,String,Double)->Unit)' : (f) => getCachedJsObject(f, (p0, p1, p2, p3) => wasmExports['__callFunction_((Double,Double,String,Double)->Unit)'](f, p0, p1, p2, p3)),
    'com.zhentech.minutepilot.web.clearBrowserDocumentDropReceiver' : () => { 
            const dragOverKey = '__minutePilotDocumentDragOver';
            const dropKey = '__minutePilotDocumentDrop';
            if (window[dragOverKey]) window.removeEventListener('dragover', window[dragOverKey]);
            if (window[dropKey]) window.removeEventListener('drop', window[dropKey]);
            delete window.__minutePilotDocumentDropReceiver;
            delete window[dragOverKey];
            delete window[dropKey];
             },
    'com.zhentech.minutepilot.web.firebaseJsonObject' : (value) => JSON.parse(value),
    'com.zhentech.minutepilot.web.firebaseAppCheckOptions' : (provider) => ({ provider: provider, isTokenAutoRefreshEnabled: true }),
    'com.zhentech.minutepilot.web.firebaseSubscribeAppCheckToken' : (promise, onSuccess, onFailure) => {
            promise.then(
                function (result) {
                    const token = result && typeof result.token === "string" ? result.token.trim() : "";
                    const error = result && result.error;
                    if (error) {
                        const code = typeof error.code === "string" ? error.code : "failed-precondition";
                        const message = typeof error.message === "string" ? error.message : "Firebase App Check token request failed.";
                        onFailure(code, message, "");
                    } else if (token) {
                        onSuccess(token);
                    } else {
                        onFailure("failed-precondition", "Firebase App Check returned no token.", "");
                    }
                },
                function (error) {
                    const code = error && typeof error.code === "string" ? error.code : "";
                    const message = error && typeof error.message === "string" ? error.message : "";
                    const details = error && error.details !== undefined ? JSON.stringify(error.details) : "";
                    onFailure(code, message, typeof details === "string" ? details : "");
                }
            );
        },
    'com.zhentech.minutepilot.web.__convertKotlinClosureToJsClosure_((String)->Unit)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((String)->Unit)'](f, p0)),
    'com.zhentech.minutepilot.web.__convertKotlinClosureToJsClosure_((String,String,String)->Unit)' : (f) => getCachedJsObject(f, (p0, p1, p2) => wasmExports['__callFunction_((String,String,String)->Unit)'](f, p0, p1, p2)),
    'com.zhentech.minutepilot.web.firebaseSubscribeCallable' : (promise, onSuccess, onFailure) => {
            promise.then(
                function (result) {
                    if (typeof result === "string") {
                        onSuccess(result);
                    } else {
                        const json = JSON.stringify(result ? result.data : undefined);
                        if (typeof json === "string") {
                            onSuccess(json);
                        } else {
                            onFailure("data-loss", "Firebase callable returned a non-JSON response.", "");
                        }
                    }
                },
                function (error) {
                    const code = error && typeof error.code === "string" ? error.code : "";
                    const message = error && typeof error.message === "string" ? error.message : "";
                    const details = error && error.details !== undefined ? JSON.stringify(error.details) : "";
                    onFailure(code, message, typeof details === "string" ? details : "");
                }
            );
        },
    'com.zhentech.minutepilot.web.configuredMinutePilotWebAppCheckSiteKey' : () => {
            const configured = window.__minutePilotAppCheckSiteKey ||
                document.querySelector('meta[name="minutepilot-app-check-site-key"]')?.content;
            return typeof configured === "string" && configured.trim().length > 0 ? configured.trim() : null;
        },
    'com.zhentech.minutepilot.web.getOrInitializeApp_$external_fun' : (_this, p0) => _this.getOrInitializeApp(p0),
    'com.zhentech.minutepilot.web.initializeAppCheck_$external_fun' : (_this, p0, p1) => _this.initializeAppCheck(p0, p1),
    'com.zhentech.minutepilot.web.getAppCheckToken_$external_fun' : (_this, p0, p1) => _this.getAppCheckToken(p0, p1),
    'com.zhentech.minutepilot.web.createReCaptchaEnterpriseProvider_$external_fun' : (_this, p0) => _this.createReCaptchaEnterpriseProvider(p0),
    'com.zhentech.minutepilot.web.createCallableProtocolRequest_$external_fun' : (_this, p0, p1, p2, p3, p4, p5) => _this.createCallableProtocolRequest(p0, p1, p2, p3, p4, p5),
    'com.zhentech.minutepilot.web.callableProtocolRequestPromise_$external_fun' : (_this, p0) => _this.callableProtocolRequestPromise(p0),
    'com.zhentech.minutepilot.web.cancelCallableProtocolRequest_$external_fun' : (_this, p0) => _this.cancelCallableProtocolRequest(p0),
    'com.zhentech.minutepilot.web.FirebaseWebSdk_$external_object_getInstance' : () => _ref_Li9maXJlYmFzZS13ZWItc2RrLm1qcw_.FirebaseWebSdk,
    'com.zhentech.minutepilot.web.browserRandomUuidOrNull' : () => globalThis.crypto?.randomUUID?.() ?? null,
    'com.zhentech.minutepilot.web.browserCurrentEpochMillisText' : () => Date.now().toString(),
    'com.zhentech.minutepilot.web.copyBrowserTextToClipboard' : (text, failureMessage, onCopied, onFailed) => { 
            const fallbackCopy = () => {
                const body = document.body;
                if (!body) {
                    onFailed(failureMessage);
                    return;
                }
                const textarea = document.createElement('textarea');
                textarea.value = text;
                textarea.setAttribute('readonly', '');
                textarea.style.position = 'fixed';
                textarea.style.top = '-1000px';
                textarea.style.left = '-1000px';
                body.appendChild(textarea);
                textarea.focus();
                textarea.select();
                let copied = false;
                try {
                    copied = !!document.execCommand && document.execCommand('copy');
                } catch (_) {
                    copied = false;
                }
                if (textarea.parentNode) textarea.parentNode.removeChild(textarea);
                if (copied) {
                    onCopied();
                } else {
                    onFailed(failureMessage);
                }
            };
            if (navigator.clipboard && navigator.clipboard.writeText) {
                navigator.clipboard.writeText(text)
                    .then(() => onCopied())
                    .catch(() => fallbackCopy());
            } else {
                fallbackCopy();
            }
             },
    'com.zhentech.minutepilot.web.pickBrowserDocxDataUrl_js_code' : (acceptedTypes, onSelectionStarted, onSelected, onFailure) => { 
            const input = document.createElement('input');
            input.type = 'file';
            input.accept = acceptedTypes;
            input.style.display = 'none';
            const cleanup = () => {
                if (input.parentNode) input.parentNode.removeChild(input);
            };
            input.onchange = () => {
                const file = input.files && input.files[0];
                if (!file) {
                    cleanup();
                    return;
                }
                const displayName = file.name || 'Selected document.docx';
                onSelectionStarted(displayName);
                const reader = new FileReader();
                reader.onerror = () => {
                    cleanup();
                    onFailure('This file could not be read. Please choose it again.');
                };
                reader.onload = () => {
                    cleanup();
                    onSelected(displayName, file.type || '', file.size || 0, reader.result || '');
                };
                reader.readAsDataURL(file);
            };
            document.body.appendChild(input);
            input.click();
             },
    'com.zhentech.minutepilot.web.__convertKotlinClosureToJsClosure_((String,String,Double,String)->Unit)' : (f) => getCachedJsObject(f, (p0, p1, p2, p3) => wasmExports['__callFunction_((String,String,Double,String)->Unit)'](f, p0, p1, p2, p3)),
    'com.zhentech.minutepilot.web.browserIndexedDbSetItemAsync' : (key, value, onResult) => 
                (() => {
                    let database = null;
                    let settled = false;
                    let timeoutId = null;
                    const finish = (result) => {
                        if (settled) return;
                        settled = true;
                        if (timeoutId !== null) globalThis.clearTimeout(timeoutId);
                        if (database) database.close();
                        onResult(result);
                    };
                    if (!globalThis.indexedDB) {
                        finish('IndexedDB is not available in this browser.');
                        return;
                    }
                    timeoutId = globalThis.setTimeout(
                        () => finish('Browser storage did not respond. Please choose this DOCX again.'),
                        12000,
                    );
                    let openRequest;
                    try {
                        openRequest = indexedDB.open('minute-pilot-web-documents', 2);
                    } catch (_) {
                        finish('IndexedDB open threw: ' + (_ && _.name ? _.name : 'unknown error'));
                        return;
                    }
                    openRequest.onupgradeneeded = () => {
                        if (settled) return;
                        const upgradedDatabase = openRequest.result;
                        if (!upgradedDatabase.objectStoreNames.contains('documents')) {
                            upgradedDatabase.createObjectStore('documents');
                        }
                    };
                    openRequest.onerror = () => finish('IndexedDB open failed: ' + (openRequest.error && openRequest.error.name ? openRequest.error.name : 'unknown error'));
                    openRequest.onblocked = () => finish('Browser storage is busy in another tab. Close the other tab and choose this DOCX again.');
                    openRequest.onsuccess = () => {
                        if (settled) {
                            openRequest.result.close();
                            return;
                        }
                        database = openRequest.result;
                        database.onversionchange = () => finish('Browser storage changed in another tab. Please choose this DOCX again.');
                        let transaction;
                        try {
                            transaction = database.transaction('documents', 'readwrite');
                            transaction.objectStore('documents').put(value, key);
                        } catch (_) {
                            finish('IndexedDB transaction setup threw: ' + (_ && _.name ? _.name : 'unknown error'));
                            return;
                        }
                        transaction.oncomplete = () => finish(null);
                        transaction.onerror = () => finish('IndexedDB write failed: ' + (transaction.error && transaction.error.name ? transaction.error.name : 'unknown error'));
                        transaction.onabort = () => finish('IndexedDB write was aborted: ' + (transaction.error && transaction.error.name ? transaction.error.name : 'unknown error'));
                    };
                })()
                ,
    'com.zhentech.minutepilot.web.__convertKotlinClosureToJsClosure_((String?)->Unit)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((String?)->Unit)'](f, p0)),
    'com.zhentech.minutepilot.web.browserIndexedDbGetItemAsync' : (key, onResult) => 
                (() => {
                    let database = null;
                    let settled = false;
                    const finish = (result) => {
                        if (settled) return;
                        settled = true;
                        if (database) database.close();
                        onResult(result);
                    };
                    if (!globalThis.indexedDB) {
                        finish(null);
                        return;
                    }
                    let openRequest;
                    try {
                        openRequest = indexedDB.open('minute-pilot-web-documents', 2);
                    } catch (_) {
                        finish(null);
                        return;
                    }
                    openRequest.onupgradeneeded = () => {
                        const upgradedDatabase = openRequest.result;
                        if (!upgradedDatabase.objectStoreNames.contains('documents')) {
                            upgradedDatabase.createObjectStore('documents');
                        }
                    };
                    openRequest.onerror = () => finish(null);
                    openRequest.onsuccess = () => {
                        database = openRequest.result;
                        let transaction;
                        let request;
                        try {
                            transaction = database.transaction('documents', 'readonly');
                            request = transaction.objectStore('documents').get(key);
                        } catch (_) {
                            finish(null);
                            return;
                        }
                        request.onsuccess = () => finish(typeof request.result === 'string' ? request.result : null);
                        request.onerror = () => finish(null);
                        transaction.onabort = () => finish(null);
                        transaction.onerror = () => finish(null);
                    };
                })()
                ,
    'com.zhentech.minutepilot.web.browserIndexedDbRemoveItemAsync' : (key, onResult) => 
                (() => {
                    let database = null;
                    let settled = false;
                    const finish = (result) => {
                        if (settled) return;
                        settled = true;
                        if (database) database.close();
                        onResult(result);
                    };
                    if (!globalThis.indexedDB) {
                        finish(false);
                        return;
                    }
                    let openRequest;
                    try {
                        openRequest = indexedDB.open('minute-pilot-web-documents', 2);
                    } catch (_) {
                        finish(false);
                        return;
                    }
                    openRequest.onupgradeneeded = () => {
                        const upgradedDatabase = openRequest.result;
                        if (!upgradedDatabase.objectStoreNames.contains('documents')) {
                            upgradedDatabase.createObjectStore('documents');
                        }
                    };
                    openRequest.onerror = () => finish(false);
                    openRequest.onsuccess = () => {
                        database = openRequest.result;
                        let transaction;
                        let store;
                        let deleted = false;
                        try {
                            transaction = database.transaction('documents', 'readwrite');
                            store = transaction.objectStore('documents');
                            const existing = store.get(key);
                            existing.onsuccess = () => {
                                if (existing.result === undefined) return;
                                deleted = true;
                                store.delete(key);
                            };
                            existing.onerror = () => transaction.abort();
                        } catch (_) {
                            finish(false);
                            return;
                        }
                        transaction.oncomplete = () => finish(deleted);
                        transaction.onerror = () => finish(false);
                        transaction.onabort = () => finish(false);
                    };
                })()
                ,
    'com.zhentech.minutepilot.web.__convertKotlinClosureToJsClosure_((Boolean)->Unit)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Boolean)->Unit)'](f, p0)),
    'com.zhentech.minutepilot.web.browserIndexedDbRemoveItemsWithPrefixAsync' : (prefix, onResult) => 
                (() => {
                    let database = null;
                    let settled = false;
                    const finish = (result) => {
                        if (settled) return;
                        settled = true;
                        if (database) database.close();
                        onResult(result);
                    };
                    if (!globalThis.indexedDB) {
                        finish(false);
                        return;
                    }
                    let openRequest;
                    try {
                        openRequest = indexedDB.open('minute-pilot-web-documents', 2);
                    } catch (_) {
                        finish(false);
                        return;
                    }
                    openRequest.onupgradeneeded = () => {
                        const upgradedDatabase = openRequest.result;
                        if (!upgradedDatabase.objectStoreNames.contains('documents')) {
                            upgradedDatabase.createObjectStore('documents');
                        }
                    };
                    openRequest.onerror = () => finish(false);
                    openRequest.onsuccess = () => {
                        database = openRequest.result;
                        let transaction;
                        let deleted = false;
                        try {
                            transaction = database.transaction('documents', 'readwrite');
                            const store = transaction.objectStore('documents');
                            const cursor = store.openKeyCursor();
                            cursor.onsuccess = () => {
                                const entry = cursor.result;
                                if (!entry) return;
                                if (typeof entry.key === 'string' && entry.key.startsWith(prefix)) {
                                    deleted = true;
                                    store.delete(entry.key);
                                }
                                entry.continue();
                            };
                            cursor.onerror = () => transaction.abort();
                        } catch (_) {
                            finish(false);
                            return;
                        }
                        transaction.oncomplete = () => finish(deleted);
                        transaction.onerror = () => finish(false);
                        transaction.onabort = () => finish(false);
                    };
                })()
                ,
    'com.zhentech.minutepilot.web.qaJourneyRequested' : () => window.__minutePilotQaJourney === true,
    'com.zhentech.minutepilot.web.localQaCallableResponse' : (functionName, requestJson) => typeof window.__minutePilotQaCallableResponse === 'function' ? window.__minutePilotQaCallableResponse(functionName, requestJson) : null,
    'com.zhentech.minutepilot.web.browserCurrentTimeText' : () => new Date().toLocaleTimeString(undefined, {hour:'numeric', minute:'2-digit'}),
    'com.zhentech.minutepilot.web.openBrowserMeetingPicker' : (kind, current, onSelected) => {
        const prior = document.getElementById('minutepilot-native-picker');
        if (prior) prior.remove();
        const invoking = document.activeElement;
        const dialog = document.createElement('dialog');
        dialog.id = 'minutepilot-native-picker';
        dialog.setAttribute('aria-label', kind === 'date' ? 'Next meeting date' : 'Next meeting time');
        dialog.style.cssText = 'border:1px solid #D8E1EB;border-radius:8px;padding:24px;color:#14213D;background:white;max-width:calc(100vw - 32px);font:inherit';
        const label = document.createElement('label');
        label.textContent = kind === 'date' ? 'Next meeting date' : 'Next meeting time';
        const input = document.createElement('input');
        input.type = kind; input.id = 'minutepilot-picker-value'; label.htmlFor = input.id;
        input.style.cssText = 'display:block;min-height:48px;font:inherit;margin:12px 0';
        if (kind === 'date') {
            const parsed = new Date(/^\d{4}-\d{2}-\d{2}$/.test(current) ? current + 'T12:00:00' : current);
            if (!Number.isNaN(parsed.getTime())) input.value = [parsed.getFullYear(), String(parsed.getMonth()+1).padStart(2,'0'), String(parsed.getDate()).padStart(2,'0')].join('-');
        } else {
            const parsed = new Date('2000-01-01 ' + current);
            if (!Number.isNaN(parsed.getTime())) input.value = String(parsed.getHours()).padStart(2,'0') + ':' + String(parsed.getMinutes()).padStart(2,'0');
        }
        const close = () => { dialog.close(); dialog.remove(); if (invoking && invoking.isConnected) invoking.focus(); };
        const save = document.createElement('button'); save.textContent = 'Use ' + kind;
        save.style.cssText = 'min-height:48px;font:inherit;padding:8px 20px;background:#2563EB;color:white;border:0;border-radius:4px;margin-right:12px';
        save.onclick = () => {
            if (!input.value || !input.reportValidity()) return;
            const value = kind === 'date'
                ? input.value
                : new Date('2000-01-01T' + input.value).toLocaleTimeString(undefined,{hour:'numeric',minute:'2-digit'});
            onSelected(value); close();
        };
        const cancel = document.createElement('button'); cancel.textContent = 'Cancel'; cancel.style.cssText = 'min-height:48px;font:inherit;padding:8px 20px'; cancel.onclick = close;
        dialog.oncancel = event => { event.preventDefault(); close(); };
        dialog.append(label,input,save,cancel); document.body.append(dialog); dialog.showModal(); input.focus();
    },
    'com.zhentech.minutepilot.web.openBrowserKeyboardHelp' : () => {
        const prior = document.getElementById('minutepilot-keyboard-help');
        if (prior) prior.remove();
        const invoking = document.activeElement;
        const dialog = document.createElement('dialog');
        dialog.id = 'minutepilot-keyboard-help';
        dialog.setAttribute('aria-labelledby', 'minutepilot-keyboard-help-title');
        dialog.style.cssText = 'box-sizing:border-box;border:1px solid #D8E1EB;border-radius:8px;padding:24px;color:#14213D;background:#FFFFFF;width:min(520px,calc(100vw - 32px));max-width:calc(100vw - 32px);max-height:calc(100vh - 32px);overflow:auto;font:inherit';
        const title = document.createElement('h2');
        title.id = 'minutepilot-keyboard-help-title';
        title.textContent = 'Live Meeting keyboard shortcuts';
        title.style.cssText = 'font:600 24px/1.2 Source Sans 3,system-ui,sans-serif;margin:0 0 16px';
        const instructions = document.createElement('p');
        instructions.textContent = 'Alt + 1: Capture\nAlt + 2: Facts\nAlt + 3: Actions\nAlt + M: Meeting Map\nAlt + Shift + ← / →: Previous / next item\nEscape: Close shortcuts or Map\n\nTab moves between controls. Browser Back and Forward keep their standard shortcuts.';
        instructions.style.cssText = 'white-space:pre-line;line-height:1.6;margin:0 0 20px';
        const closeButton = document.createElement('button');
        closeButton.textContent = 'Close shortcuts';
        closeButton.style.cssText = 'min-height:48px;font:600 16px Source Sans 3,system-ui,sans-serif;padding:8px 20px;background:#2563EB;color:#FFFFFF;border:0;border-radius:4px';
        let closed = false;
        const close = () => {
            if (closed) return;
            closed = true;
            if (dialog.open) dialog.close();
            dialog.remove();
            if (invoking && invoking.isConnected) invoking.focus();
        };
        closeButton.onclick = close;
        dialog.oncancel = event => { event.preventDefault(); close(); };
        dialog.onkeydown = event => {
            if (event.key === 'Tab') {
                event.preventDefault();
                closeButton.focus();
            }
        };
        dialog.append(title, instructions, closeButton);
        document.body.append(dialog);
        dialog.showModal();
        closeButton.focus();
    },
    'com.zhentech.minutepilot.web.openBrowserAgendaSource' : (sourceText) => {
        const prior = document.getElementById('minutepilot-agenda-source');
        if (prior) prior.remove();
        const invoking = document.activeElement;
        const dialog = document.createElement('dialog');
        dialog.id = 'minutepilot-agenda-source';
        dialog.setAttribute('aria-labelledby', 'minutepilot-agenda-source-title');
        dialog.setAttribute('aria-describedby', 'minutepilot-agenda-source-description');
        dialog.style.cssText = 'box-sizing:border-box;border:1px solid #D8E1EB;border-radius:8px;padding:24px;color:#14213D;background:#FFFFFF;width:min(760px,calc(100vw - 32px));max-width:calc(100vw - 32px);max-height:calc(100vh - 32px);overflow:auto;font:16px/1.5 Source Sans 3,system-ui,sans-serif';
        const title = document.createElement('h2');
        title.id = 'minutepilot-agenda-source-title';
        title.textContent = 'Original agenda text';
        title.style.cssText = 'font:600 24px/1.2 Source Sans 3,system-ui,sans-serif;margin:0 0 8px';
        const description = document.createElement('p');
        description.id = 'minutepilot-agenda-source-description';
        description.textContent = 'Read-only text from the copied agenda. Live capture and preparation edits do not change it.';
        description.style.cssText = 'color:#5F6F82;margin:0 0 16px';
        const source = document.createElement('div');
        source.tabIndex = 0;
        source.setAttribute('aria-label', 'Agenda source text');
        source.textContent = sourceText.trim() || 'Source text could not be extracted. The copied agenda remains attached.';
        source.style.cssText = 'box-sizing:border-box;white-space:pre-wrap;overflow-wrap:anywhere;padding:16px;margin:0 0 20px;background:#F1F5F9;border:1px solid #D8E1EB;border-radius:4px;max-height:min(58vh,560px);overflow:auto;user-select:text';
        const closeButton = document.createElement('button');
        closeButton.textContent = 'Return to Live Meeting';
        closeButton.style.cssText = 'min-height:48px;font:600 16px Source Sans 3,system-ui,sans-serif;padding:8px 20px;background:#2563EB;color:#FFFFFF;border:0;border-radius:4px';
        let closed = false;
        const close = () => {
            if (closed) return;
            closed = true;
            if (dialog.open) dialog.close();
            dialog.remove();
            if (invoking && invoking.isConnected) invoking.focus();
        };
        closeButton.onclick = close;
        dialog.oncancel = event => { event.preventDefault(); close(); };
        dialog.onkeydown = event => {
            if (event.key !== 'Tab') return;
            const focusable = [source, closeButton];
            const first = focusable[0]; const last = focusable[focusable.length - 1];
            if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
            else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
        };
        dialog.append(title, description, source, closeButton);
        document.body.append(dialog);
        dialog.showModal();
        closeButton.focus();
    },
    'com.zhentech.minutepilot.web.installLiveKeyboardShortcuts' : (onShortcut) => (() => {
        const listener = event => {
            if (event.isComposing || event.ctrlKey || event.metaKey || document.querySelector('dialog[open]')) return;
            let command = null;
            if (event.altKey && !event.shiftKey) command = ({Digit1:'1',Digit2:'2',Digit3:'3'})[event.code] || null;
            if (event.altKey && !event.shiftKey && event.code === 'KeyM') command = 'map';
            if (event.altKey && event.shiftKey && event.key === 'ArrowLeft') command = 'previous';
            if (event.altKey && event.shiftKey && event.key === 'ArrowRight') command = 'next';
            if (event.key === 'Escape') command = 'close';
            if (command) { event.preventDefault(); onShortcut(command); }
        };
        window.addEventListener('keydown',listener);
        return () => window.removeEventListener('keydown',listener);
    })(),
    'com.zhentech.minutepilot.web.installBrowserUnloadGuard' : (hasUnsavedChanges) => (() => {
        const listener = event => { if (hasUnsavedChanges()) { event.preventDefault(); event.returnValue = ''; } };
        window.addEventListener('beforeunload', listener);
        return () => window.removeEventListener('beforeunload', listener);
    })(),
    'com.zhentech.minutepilot.web.__convertKotlinClosureToJsClosure_(()->Boolean)' : (f) => getCachedJsObject(f, () => wasmExports['__callFunction_(()->Boolean)'](f, )),
    'com.zhentech.minutepilot.web.installWebEscapeHandler' : (onDismiss) => (() => {
        const listener = event => {
            if (event.key === 'Escape') { event.preventDefault(); event.stopPropagation(); onDismiss(); }
        };
        window.addEventListener('keydown', listener, true);
        return () => window.removeEventListener('keydown', listener, true);
    })(),
    'com.zhentech.minutepilot.web.currentBrowserQuery' : () => window.location.search,
    'com.zhentech.minutepilot.web.pushBrowserQuery' : (query, index) => window.history.pushState({minutePilotIndex:index}, '', query),
    'com.zhentech.minutepilot.web.replaceBrowserQuery' : (query, index) => window.history.replaceState({minutePilotIndex:index}, '', query),
    'com.zhentech.minutepilot.web.addBrowserPopListener' : (listener) => window.addEventListener('popstate', listener),
    'com.zhentech.minutepilot.web.removeBrowserPopListener' : (listener) => window.removeEventListener('popstate', listener),
    'com.zhentech.minutepilot.web.currentBrowserHistoryIndex' : () => Number.isInteger(window.history.state?.minutePilotIndex) ? window.history.state.minutePilotIndex : 0,
    'com.zhentech.minutepilot.web.ensureBrowserHistoryIndex' : () => (() => { if (!Number.isInteger(window.history.state?.minutePilotIndex)) window.history.replaceState({minutePilotIndex:0}, '', window.location.href); return window.history.state.minutePilotIndex; })(),
    'com.zhentech.minutepilot.web.goBrowserHistory' : (delta) => window.history.go(delta),
    'com.zhentech.minutepilot.web.browserTextScale' : () => Math.min(3, Math.max(0.8, parseFloat(getComputedStyle(document.documentElement).fontSize) / 16)),
    'com.zhentech.minutepilot.web.observeBrowserTextScale' : (onChanged) => (() => {
        const observer = new MutationObserver(onChanged);
        observer.observe(document.documentElement, {attributes:true, attributeFilter:['style','class']});
        window.addEventListener('resize',onChanged);
        return () => {observer.disconnect();window.removeEventListener('resize',onChanged);};
    })(),
    'com.zhentech.minutepilot.web.isLocalQaIdentityEnabled' : () => 
        window.__minutePilotQaIdentity === true &&
          (window.location.hostname === '127.0.0.1' || window.location.hostname === 'localhost')
        ,
    'com.zhentech.minutepilot.web.encodeCheckpointPart' : (value) => encodeURIComponent(value),
    'com.zhentech.minutepilot.web.decodeCheckpointPart' : (value) => decodeURIComponent(value)
}

const StringConstantsProxy = new Proxy({}, {
  get(_, prop) { return prop; }
});

export { wasmTag as __TAG };

export const importObject = {
    js_code,
    intrinsics: {
        tag: wasmTag
    },
    "'": StringConstantsProxy,
    'wasm:js-string': d2FzbTpqcy1zdHJpbmc,
    './skiko.mjs': Li9za2lrby5tanM,
};
    